export interface MelonCategory {
  id: string;
  name: string;
  desc: string;
  icon: string;
  count: number;
}

export interface MelonArticle {
  id: string;
  title: string;
  categoryId: string;
  categoryName: string;
  tagLabel: string;
  summary: string;
  image: string;
  host: string;
  time: string;
  readMin: number;
  viewsText: string;
  likesText: string;
  commentsText: string;
  heat: number;
  heatLabel: string;
  series: 'featured' | 'collection';
  content: string[];
  points: string[];
}

export interface FaqItem {
  q: string;
  a: string;
}

export const siteName = '快手吃瓜瓜料大全';
export const siteUrl = 'https://hongem.cn';
export const contactEmail = 'hello@gua.reddy.site';

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '今日热榜', href: '/#hot' },
  { label: '瓜田精选', href: '/#featured' },
  { label: '瓜田盘点', href: '/#collections' },
  { label: '常见问题', href: '/#faq' },
  { label: '关于我们', href: '/about' },
];

export const categories: MelonCategory[] = [
  { id: 'live', name: '直播带货', desc: '价格、翻车与选品那些事', icon: 'ri-shopping-bag-3-line', count: 128 },
  { id: 'circle', name: '主播圈', desc: '圈内人脉与幕后瓜', icon: 'ri-user-heart-line', count: 96 },
  { id: 'brand', name: '品牌争议', desc: '商家博弈与口碑风向', icon: 'ri-flag-2-line', count: 74 },
  { id: 'show', name: '综艺饭圈', desc: '节目话题与粉丝热论', icon: 'ri-vidicon-line', count: 61 },
  { id: 'rule', name: '平台新规', desc: '机制调整与行业观察', icon: 'ri-file-list-3-line', count: 42 },
  { id: 'story', name: '口碑故事', desc: '涨粉与翻红全过程', icon: 'ri-movie-2-line', count: 53 },
];

export const articles: MelonArticle[] = [
  {
    id: 'price-warranty',
    title: '某头部带货主播深夜道歉：这次「价保」到底翻了谁的车？',
    categoryId: 'live',
    categoryName: '直播带货',
    tagLabel: '爆',
    summary: '一纸价保公告引发连锁反应，从「保价七天」到「背刺老铁」，头部主播的信任成本正在被重新计价。',
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20a%20price%20tag%20being%20flipped%20over%20by%20a%20hand%20inside%20a%20shopping%20cart%2C%20scattered%20receipts%20and%20coins%2C%20warm%20cream%20paper%20background%2C%20vermillion%20red-orange%20and%20golden%20yellow%20flat%20vector%20palette%2C%20soft%20rounded%20shapes%2C%20editorial%20minimal%2C%20no%20text&width=900&height=600&seq=g1-price&orientation=landscape',
    host: '桃子姐',
    time: '昨天 22:40',
    readMin: 6,
    viewsText: '326.4万',
    likesText: '18.2万',
    commentsText: '4.7万',
    heat: 9862,
    heatLabel: '9862.4万',
    series: 'featured',
    content: [
      '一句「我们一定是最低价的」在电商圈不算新鲜，可当同一件商品在大促前后被扒出差价时，这句话就变成了一根随时会落地的稻草。昨晚九点半，某头部带货主播突然开播，没有预告也没有连麦，对着镜头直接鞠躬道歉，承认活动价保口径存在误导，并给出差价的「双倍返券」方案。',
      '从评论区来看，老铁们的态度分成两派。一部分人觉得态度诚恳、弥补到位，「给桃子姐留条后路」；另一部分则翻出过往几次类似说辞，认为「价保」早已沦为话术，关键在于每次翻车后如何兜底，而不是翻车前把话说满。',
      '真正让这件事变复杂的，是它背后牵扯的品牌方与供应链。爆料称部分商家为冲销量临时改价、随后被平台风控拦截，导致价差责任难以单方认定。这场「谁在说谎」的拉锯，恐怕还要持续好几天。',
    ],
    points: [
      '主播公开道歉并承诺价差双倍返券，但口径仍需澄清',
      '品牌方与供应链临时改价被风控，责任归属存争议',
      '网友观点两极：谅解派与追责派各执一词',
      '行业普遍呼吁价保规则透明化，避免「话术性价保」',
    ],
  },
  {
    id: 'clear-account',
    title: '老铁们破防了：当红段子手连夜清空百万粉丝账号，背后藏着什么？',
    categoryId: 'circle',
    categoryName: '主播圈',
    tagLabel: '热',
    summary: '从一个视频爆红到账号一夜清空，百万级段子手「消失」得如此突然，评论区只剩下一句：互联网没有永远的热搜。',
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20a%20cellphone%20screen%20with%20an%20empty%20blank%20avatar%20and%20question%20mark%2C%20falling%20confetti%20and%20speech%20bubbles%20around%2C%20warm%20cream%20paper%20background%2C%20vermillion%20and%20golden%20flat%20vector%20palette%2C%20soft%20rounded%20shapes%2C%20editorial%20minimal%2C%20no%20text&width=900&height=600&seq=g2-clear&orientation=landscape',
    host: '灯哥',
    time: '前天 21:15',
    readMin: 5,
    viewsText: '198.7万',
    likesText: '11.3万',
    commentsText: '2.1万',
    heat: 8120,
    heatLabel: '8120.7万',
    series: 'featured',
    content: [
      '很多人认识灯哥，是从那条把「老铁互赞」玩成连续剧的搞笑视频开始的。短短三个月，他从几千粉一路冲到百万，靠的不是才艺，而是一套极具辨识度的「反套路」人设。可就在上周日晚间，粉丝发现他的主页被一夜清空，只剩一条「江湖再见」的公告。',
      '对于离开原因，外界猜测众多。有说和平台分成谈不拢，有说账号已高价转手给机构，也有老粉顺着蛛丝马迹扒出他疑似与原团队产生分成纠纷，最终选择「一键清零」止损。',
      '截至目前，灯哥并未在任何平台给出详细解释。但一个值得注意的细节是：清空前一天，他刚点赞了一条关于「创作者与机构分成」的行业吐槽视频。究竟是隐喻还是巧合，暂时无从考证，唯一确定的是，这条百万粉账号的「消失」，本身就是一条极具传播度的瓜。',
    ],
    points: [
      '百万粉账号一夜清空，仅保留「江湖再见」公告',
      '离开原因众说纷纭：分成、机构纠纷与账号转手',
      '清空前点赞「分成吐槽」被老粉视为关键线索',
      '账号归零背后折射创作者与机构分成制度的痛点',
    ],
  },
  {
    id: 'white-label',
    title: '一件白牌服装卖爆 30 万单，评论区却吵翻：品牌争议背后的选品逻辑',
    categoryId: 'brand',
    categoryName: '品牌争议',
    tagLabel: '热',
    summary: '销量登顶与口碑翻车同框出现，白牌不是原罪，真正值得追问的，是直播间到底在卖「品质」还是在卖「冲动」。',
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20a%20hanging%20t-shirt%20and%20scissors%20and%20fabric%20samples%20on%20a%20sewing%20table%2C%20warm%20cream%20paper%20background%2C%20vermillion%20red-orange%20and%20golden%20yellow%20flat%20vector%20palette%2C%20soft%20rounded%20shapes%2C%20editorial%20minimal%2C%20no%20text&width=900&height=600&seq=g3-white&orientation=landscape',
    host: '二狗测评',
    time: '前天 19:02',
    readMin: 6,
    viewsText: '251.6万',
    likesText: '9.8万',
    commentsText: '3.4万',
    heat: 7640,
    heatLabel: '7640.2万',
    series: 'featured',
    content: [
      '一款没有任何品牌的休闲卫衣，靠主播一句「源头工厂价，吊牌价 399 今天只要 59」，在 48 小时内卖出 30 万单。销量是造假的，口碑却不是——几天后，一条条关于「线头、缩水、掉色」的晒单开始攻占评论区。',
      '争议的核心并不在于「白牌能不能卖」，而在于直播间的选品逻辑是否以真实品质为底线。支持者认为，白牌给了普通人用低价买到基础款的机会，不能因为少数质量问题全盘否定；反对者则指出，低价不等于可以模糊面料与工艺信息，主播有义务把「能穿」讲成「好穿」之前先自己把过关。',
      '二狗测评在最新一期视频中回应，称已对同批次产品安排三方送检，并承诺「品质不达标就召回退款」。这场由一件卫衣引发的品牌与信任之争，也被许多老铁戏称为「今年最接地气的商战」。',
    ],
    points: [
      '无品牌卫衣 48 小时卖出 30 万单，销量与口碑冰火两重天',
      '晒单吐槽集中在线头、缩水与掉色等基础品控问题',
      '争议焦点：白牌价值 vs 直播间选品真实底线',
      '主播承诺三方送检并召回退款，事件仍在发酵',
    ],
  },
  {
    id: 'variety-show',
    title: '综艺「新一届」开播即火：饭圈应援和路人口碑为何两极？',
    categoryId: 'show',
    categoryName: '综艺饭圈',
    tagLabel: '新',
    summary: '同一档节目，粉丝在超话里狂欢，路人在评论区吐槽。当综艺越来越懂流量，观众却越来越难被打动。',
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20a%20tv%20screen%20with%20stage%20spotlights%20and%20microphones%2C%20clapping%20hands%20and%20light%20sticks%2C%20warm%20cream%20paper%20background%2C%20vermillion%20red-orange%20and%20golden%20yellow%20flat%20vector%20palette%2C%20soft%20rounded%20shapes%2C%20editorial%20minimal%2C%20no%20text&width=900&height=600&seq=g4-show&orientation=landscape',
    host: '新一届官微',
    time: '周一 12:30',
    readMin: 5,
    viewsText: '88.9万',
    likesText: '3.2万',
    commentsText: '0.9万',
    heat: 4530,
    heatLabel: '4530.5万',
    series: 'featured',
    content: [
      '现象级选秀综艺《新一届》第二季开播，首期便拿下多个平台热搜。节目把镜头从舞台搬到排练室，试图用「真实努力」打动观众，这一设计确实让粉丝兴奋不已——应援站连夜开工，超话讨论量翻了好几倍。',
      '但把进度条拉到路人视角，感受却是另一回事。不少普通观众吐槽剪辑节奏拖沓、植入生硬，认为节目「把故事讲得比舞台还长」。饭圈强调的「细节糖」，在路人眼里反而成了「注水」。同一批素材，两种读法。',
      '业内人士分析，选秀综艺早已从「拼舞台」转向「拼叙事」，谁能让粉丝产生养成感谁就赢。可当叙事与流量绑定过深，节目就陷入「服务粉丝」与「讨好路人」的两难，这也是口碑两极的根本原因。',
    ],
    points: [
      '《新一届》第二季首期拿下多个平台热搜',
      '饭圈专注舞台下的「养成叙事」，应援热情高涨',
      '路人吐槽剪辑拖沓、植入生硬，两种观感对立',
      '选秀综艺陷入「服务粉丝」与「讨好路人」的两难',
    ],
  },
  {
    id: 'new-rules',
    title: '平台连出三道新规：直播带货下半场，拼的不再是嗓门',
    categoryId: 'rule',
    categoryName: '平台新规',
    tagLabel: '新',
    summary: '从流量倾斜到内容审核，一连串规则落地让不少主播连夜改方案。属于「喊麦式带货」的时代，正在被悄然改写。',
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20a%20clipboard%20with%20checklist%20and%20megaphone%20and%20gears%2C%20policy%20documents%20stacked%2C%20warm%20cream%20paper%20background%2C%20vermillion%20red-orange%20and%20golden%20yellow%20flat%20vector%20palette%2C%20soft%20rounded%20shapes%2C%20editorial%20minimal%2C%20no%20text&width=900&height=600&seq=g5-rules&orientation=landscape',
    host: '平台观察站',
    time: '周日 10:05',
    readMin: 6,
    viewsText: '120.3万',
    likesText: '6.1万',
    commentsText: '1.5万',
    heat: 5210,
    heatLabel: '5210.8万',
    series: 'featured',
    content: [
      '不到两周，平台密集落地三项新规：直播间「虚假憋单」内容将被限流、模糊「过款价」宣传需在醒目处标注建议零售价、以及将「秒杀库存」与主播信用分直接挂钩。三条规则方向一致——把消费者被透支的耐心还回去。',
      '规则落地首日，不少以「仅剩最后 3 单」为口头禅的主播明显收敛。据多位从业者反馈，最伤筋动骨的是「秒杀库存」信用分机制：以往先虚挂库存再放量的打法，现在稍有不慎就会影响账号权重。',
      '短期来看，套路型话术会加速退场；长期来看，比拼的内容质量、供应链真实度和售后能力。可以预见，能留下的是把直播当作「长效经营」而非「一次性收割」的人，而那些只想赚快钱的主播，将越来越难在台前站稳。',
    ],
    points: [
      '三项新规针对虚假憋单、模糊过款价与秒杀库存',
      '限流与信用分机制让套路型话术明显收敛',
      '「先虚挂后放量」的老打法风险骤增',
      '行业共识：直播带货正向内容与供应链比拼转型',
    ],
  },
  {
    id: 'liaomai',
    title: '连麦翻车名场面复盘：那句没绷住的话，如何炸掉整个直播间',
    categoryId: 'live',
    categoryName: '直播带货',
    tagLabel: '爆',
    summary: '一场本意是带节奏涨人气的连麦，因一句情绪失控的失言瞬间出圈，直播间从热闹变成围观，最后只剩一地鸡毛。',
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20two%20connected%20video%20call%20windows%20with%20a%20burst%20speech%20bubble%20crack%20in%20the%20middle%2C%20warm%20cream%20paper%20background%2C%20vermillion%20red-orange%20and%20golden%20yellow%20flat%20vector%20palette%2C%20soft%20rounded%20shapes%2C%20editorial%20minimal%2C%20no%20text&width=900&height=600&seq=g6-liaomai&orientation=landscape',
    host: '瓜姐说事',
    time: '周六 23:10',
    readMin: 5,
    viewsText: '176.2万',
    likesText: '14.5万',
    commentsText: '5.2万',
    heat: 8940,
    heatLabel: '8940.3万',
    series: 'featured',
    content: [
      '在短视频生态里，连麦本是一种高效的流量玩法：两个主播互相带人气，把冲突感做足，把话头抛给对面，热闹往往就这么来了。可当火候掌握不好，连麦就容易变成「引火烧身」。上周的一场连麦，就演变成了教科书级的翻车现场。',
      '起因是两位主播为了一款产品的「全网最低价」互相呛声，起初还算点到为止，可当一方甩出「你家货正不正经自己心里没数」时，场面彻底失控。情绪上头的另一方没绷住，一句针对对面粉丝的失言脱口而出，直播间在线人数当场冲上百万，却几乎全是来看热闹的。',
      '复盘这场连麦，人气是赚到了，口碑却输了。事后双方先后停播，用一场又一场「解释」来收拾残局。行业里常说「连麦一时爽，翻车火葬场」，这句玩笑话，正在被越来越多主播用真金白银验证。',
    ],
    points: [
      '为争「全网最低价」互呛，场面从冲突升级为失言',
      '一句针对粉丝的失言让直播间人气瞬间破百万',
      '复盘：人气赚到了、口碑与信任却双双受损',
      '双方先后停播解释，事件被网友整理成翻车合集',
    ],
  },
  {
    id: 'half-year-review',
    title: '快手吃瓜瓜田盘点：2026 上半年十大必吃瓜，你错过了几个？',
    categoryId: 'story',
    categoryName: '口碑故事',
    tagLabel: '盘点',
    summary: '从价保翻车到账号清空，从白牌争议到新规落地。我们把上半年最值得回味、讨论度最高的瓜，一次性给你盘清楚。',
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20a%20large%20calendar%20wall%20with%20numbered%20watermelon%20chips%20and%20a%20magnifier%20glass%2C%20warm%20cream%20paper%20background%2C%20vermillion%20red-orange%20and%20golden%20yellow%20flat%20vector%20palette%2C%20soft%20rounded%20shapes%2C%20editorial%20minimal%2C%20no%20text&width=900&height=600&seq=g7-halfyear&orientation=landscape',
    host: '编辑部盘点组',
    time: '2026-07-02',
    readMin: 12,
    viewsText: '512.8万',
    likesText: '36.5万',
    commentsText: '8.9万',
    heat: 12650,
    heatLabel: '12650.9万',
    series: 'collection',
    content: [
      '2026 上半年，快手吃瓜的瓜田格外热闹。直播带货的信任危机、主播圈的账号归零、白牌商品的品质争议、平台新规的接连落地……每一颗瓜都在提醒我们：流量来得快，去得也快，唯有真实的内容才能长久留人。',
      '如果只能用一句话概括上半年，那就是「从喊麦式带货走向内容式经营」。那些真正被留下口碑的主播，靠的不是嗓门，而是经得起翻车测试的选品与售后。',
      '这份盘点不是为了站队，而是想帮你把散落在各处的碎片信息串起来，看清每颗瓜背后的来龙去脉。下面我们就按讨论热度，把上半年最具代表性的瓜一件件摊开来看。',
    ],
    points: [
      '十大盘点覆盖带货、圈内、品牌与平台新规等主线',
      '上半年关键词：信任危机、账号归零与规则重塑',
      '头部主播用售后行动重建口碑成为新趋势',
      '完整榜单与复盘全文收录于本盘点合集',
    ],
  },
  {
    id: 'collapse-story',
    title: '吃瓜合集：从爆红到塌房，一位主播翻车史全记录',
    categoryId: 'story',
    categoryName: '口碑故事',
    tagLabel: '合集',
    summary: '三个月涨粉千万，七天跌回原点。我们回放了一条完整的内容曲线：走红靠人设，塌房也往往靠人设。',
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20a%20rollercoaster%20going%20up%20then%20falling%20sharply%20with%20small%20figures%20and%20falling%20chips%2C%20warm%20cream%20paper%20background%2C%20vermillion%20red-orange%20and%20golden%20yellow%20flat%20vector%20palette%2C%20soft%20rounded%20shapes%2C%20editorial%20minimal%2C%20no%20text&width=900&height=600&seq=g8-collapse&orientation=landscape',
    host: '编辑部合集组',
    time: '2026-06-28',
    readMin: 10,
    viewsText: '403.5万',
    likesText: '27.9万',
    commentsText: '6.3万',
    heat: 10780,
    heatLabel: '10780.1万',
    series: 'collection',
    content: [
      '在流量场里，「人设」是最便宜的入场券，也是最高昂的维护成本。本合集收录的那位主播，用三个月走完了别人几年的路，又用七天把这条路重新走了一遍——只不过这一次是向下。',
      '翻车前的流量密码并不复杂：一个足够真诚的「老铁人设」，配上敢说敢怼的内容风格。可惜当人设与现实出现裂缝，再坚固的粉丝滤镜也会出现裂纹。真正引爆舆论的，往往是过往视频里被网友逐帧「考古」出的言行不一。',
      '这条曲线值得每个内容创作者反复看：涨粉靠的是差异化，留住人靠的是表里如一。所谓塌房，很多时候不是天降横祸，而是长期言行落差的集中兑现。',
    ],
    points: [
      '完整回放「三个月涨粉千万、七天跌回原点」的曲线',
      '走红靠人设，塌房往往也源于人设与现实的裂缝',
      '逐帧「考古」旧视频成为舆论发酵的关键推手',
      '对创作者的核心启示：差异化涨粉、表里如一留人',
    ],
  },
  {
    id: 'emotion-line',
    title: '瓜田盘点：本季度网红情感线全回顾，分分合合都有谁',
    categoryId: 'circle',
    categoryName: '主播圈',
    tagLabel: '盘点',
    summary: '感情话题永远是吃瓜流量的常青树。这一季度，主播们的分分合合与官宣、复联，串成了一条完整的情感瓜线。',
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20two%20broken%20heart%20halves%20reconnecting%20with%20a%20red%20thread%2C%20love%20letters%20and%20phone%20chats%20floating%2C%20warm%20cream%20paper%20background%2C%20vermillion%20red-orange%20and%20golden%20yellow%20flat%20vector%20palette%2C%20soft%20rounded%20shapes%2C%20editorial%20minimal%2C%20no%20text&width=900&height=600&seq=g9-emotion&orientation=landscape',
    host: '编辑部盘点组',
    time: '2026-07-12',
    readMin: 9,
    viewsText: '287.4万',
    likesText: '19.6万',
    commentsText: '7.2万',
    heat: 9320,
    heatLabel: '9320.6万',
    series: 'collection',
    content: [
      '如果说带货瓜拼的是选品与耐心，那情感瓜拼的纯粹是叙事张力。这一季度，多对主播CP的感情线相继更新：有人高调官宣，有人深夜发文疑似分道扬镳，也有人时隔数月的「复联」让老粉直呼破镜重圆。',
      '情感瓜最特殊的地方在于，当事人的每一句模棱两可，都会被解读成无数种版本。我们无意也无力考证感情真伪，只想把这些公开的动态按时间线整理清楚，帮你看懂来龙去脉，少被标题党带节奏。',
      '需要提醒的是：感情是私事，围观要有分寸。磕到真的固然开心，看到反转也不必急着站队。瓜田虽好，理性吃瓜才是长久之道。',
    ],
    points: [
      '按时间线整理本季度主播 CP 的官宣与分合动态',
      '多条情感线出现「复联」，引发破镜重圆猜测',
      '强调梳理公开信息，不盲信标题党与断章取义',
      '呼吁理性吃瓜：围观私事保持基本分寸',
    ],
  },
  {
    id: 'year-combat',
    title: '直播电商瓜料大全：年度价格战与翻车名场面精华总结',
    categoryId: 'live',
    categoryName: '直播带货',
    tagLabel: '合集',
    summary: '价格战打到白热化、翻车名场面轮番上演。这份精华总结收录了今年最值得回味的电商瓜，一次看够。',
    image: 'https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20two%20boxing%20gloves%20facing%20each%20other%20above%20a%20price%20tag%20and%20shield%2C%20warm%20cream%20paper%20background%2C%20vermillion%20red-orange%20and%20golden%20yellow%20flat%20vector%20palette%2C%20soft%20rounded%20shapes%2C%20editorial%20minimal%2C%20no%20text&width=900&height=600&seq=g10-yearcombat&orientation=landscape',
    host: '编辑部合集组',
    time: '2026-08-19',
    readMin: 11,
    viewsText: '348.9万',
    likesText: '24.3万',
    commentsText: '5.8万',
    heat: 11360,
    heatLabel: '11360.4万',
    series: 'collection',
    content: [
      '把「全网最低价」当成口头禅的时代正在过去，取而代之的是一场围绕供应链、选品与售后展开的漫长价格战。这份瓜料大全，收录了年度最具代表性的价格博弈与翻车瞬间，帮你一键补齐进度。',
      '从大促前夕的临时改价，到直播间里失控的连麦互呛，再到白牌商品的品控风波，每一件事单看是独立瓜，连起来却是一条清晰的行业脉络：低价竞争的红利正在收窄，谁先建立信任，谁就握住下一轮增长。',
      '我们把这些碎片整理成精华总结，不为蹭热度，只为让关心直播电商的老铁们，能用最短的时间看清这一年行业发生了什么、正在往哪里去。',
    ],
    points: [
      '年度价格战与翻车名场面一次收录、进度一键补齐',
      '梳理大促改价、连麦互呛与白牌品控等典型案例',
      '揭示行业主线：低价红利收窄、信任成为新壁垒',
      '本合集持续更新，欢迎老铁随时回来补瓜',
    ],
  },
];

export const hotRankIds: { id: string; rank: number }[] = [
  { id: 'half-year-review', rank: 1 },
  { id: 'price-warranty', rank: 2 },
  { id: 'year-combat', rank: 3 },
  { id: 'liaomai', rank: 4 },
  { id: 'collapse-story', rank: 5 },
  { id: 'emotion-line', rank: 6 },
  { id: 'clear-account', rank: 7 },
  { id: 'white-label', rank: 8 },
];

export const faqs: FaqItem[] = [
  {
    q: '快手吃瓜和普通刷动态有什么区别？',
    a: '普通刷动态需要你自己挨个关注、频繁刷新，信息又散又容易漏。快手吃瓜瓜料大全把这些分散的瓜料按时间线与事件主线重新整理成瓜田盘点、精品瓜与吃瓜合集，让你一条读完就能补齐必吃瓜，省下大量时间。',
  },
  {
    q: '网站上的瓜料来源可靠吗？会不会是编的？',
    a: '我们坚持「先整理、再呈现」的原则：所有瓜田盘点都会标注事件时间与公开信息脉络，尽量呈现多方说法，而不是只转述单方标题。对于缺乏公开佐证的传闻，我们会明确提示为「网传待核实」，不做添油加醋的二次创作。',
  },
  {
    q: '为什么同一个瓜会看到不同的版本？',
    a: '很多瓜本身就处在不断反转中，不同阶段公开的信息不同，自然会产生多个版本。这正是我们按时间线整理的原因——帮你厘清「最先说什么、后来改了什么、最终如何收场」，少被单一片段带节奏。',
  },
  {
    q: '瓜田盘点多久更新一次？',
    a: '热门瓜通常会在事件有阶段性进展后的 24 小时内更新盘点；每周我们还会整理一次「本周必吃瓜」合集，并定期推出覆盖更长周期的专题瓜料大全，方便你集中补齐进度。',
  },
  {
    q: '我可以投稿或补充新瓜吗？',
    a: '当然可以。我们非常欢迎瓜友们提供线索与时间线补充。投稿时请尽量附上可核对的公开链接与时间节点，编辑部会优先核实并整理进对应分类，让瓜田更完整。',
  },
  {
    q: '吃瓜会不会涉及侵犯隐私？',
    a: '我们只整理已公开、且具备公共讨论度的信息，不涉及对当事人私人信息的挖掘与扩散，也坚持不传播未经证实的隐私细节。理性吃瓜、尊重当事人，是我们长期坚持的底线。',
  },
];

export function getArticleById(id: string): MelonArticle | undefined {
  return articles.find((a) => a.id === id);
}

export function getCategoryName(id: string): string {
  return categories.find((c) => c.id === id)?.name ?? '综合瓜田';
}